// 1. [供应商准入]PC端列表页状态
export const admittanceProductClass_Enum = [
	{
		comment: '待处理',
		code: '0'
	},
	{
		comment: '资料填报中',
		code: '1'
	},
	{
		comment: '资料已填报完成',
		code: '2'
	},
	{
		comment: '暂不合作',
		code: '5'
	}
]

export const admittanceProductClass_Show = enumToFilter(admittanceProductClass_Enum);

export const baseTrueOrFalse = [
	{
		comment: '是',
		code: '1'
	},
	{
		comment: '否',
		code: '0'
	}
]
export const baseTrueOrFalse_Show = enumToFilter(baseTrueOrFalse);

export const baseGoOrStop = [
	{
		comment: '停用',
		code: '1'
	},
	{
		comment: '正常',
		code: '0'
	}
]
export const baseGoOrStop_Show = enumToFilter(baseGoOrStop);

export const baseHasOrNot = [
	{
		comment: '无',
		code: '0'
	},
	{
		comment: '有',
		code: '1'
	}
]
export const baseCooperationOrNot = [
	{
		comment: '未合作',
		code: '0'
	},
	{
		comment: '合作',
		code: '1'
	}
]

export const baseNeedOrNot = [
	{
		comment: '需要',
		code: '1'
	},
	{
		comment: '不需要',
		code: '0'
	}
]

export const declarationInfoOwnOrNot = [
	{
		comment: '自有',
		code: '1'
	},
	{
		comment: '租用',
		code: '0'
	}
]
export const patternAttribute = [
	{
		comment: '面料A',
		code: '面料A'
	},
	{
		comment: '面料B',
		code: '面料B'
	},
	{
		comment: '撞料',
		code: '撞料'
	},
	{
		comment: '袋布',
		code: '袋布'
	},
	{
		comment: '里料',
		code: '里料'
	},
	{
		comment: '朴',
		code: '朴'
	},
	{
		comment: '捆条',
		code: '捆条'
	},
	{
		comment: '罗纹',
		code: '罗纹'
	},
]
export const patternAttributePlain = [
	/*棉朴
大衣朴
真丝朴
丝绒朴(薄)
丝绒朴(厚)
针织朴
牛仔酵洗朴
弹袖棉
皮草朴
挂面朴
腰头用
西服朴
双面朴
厚大衣朴
防棉朴
	* */
	{
		comment: '棉朴',
		code: '棉朴'
	},
	{
		comment: '大衣朴',
		code: '大衣朴'
	},
	{
		comment: '真丝朴',
		code: '真丝朴'
	},
	{
		comment: '丝绒朴(薄)',
		code: '丝绒朴(薄)'
	},
	{
		comment: '丝绒朴(厚)',
		code: '丝绒朴(厚)'
	},
	{
		comment: '针织朴',
		code: '针织朴'
	},
	{
		comment: '牛仔酵洗朴',
		code: '牛仔酵洗朴'
	},
	{
		comment: '弹袖棉',
		code: '弹袖棉'
	},
	{
		comment: '皮草朴',
		code: '皮草朴'
	},
	{
		comment: '挂面朴',
		code: '挂面朴'
	},
	{
		comment: '腰头用',
		code: '腰头用'
	},
	{
		comment: '西服朴',
		code: '西服朴'
	},
	{
		comment: '双面朴',
		code: '双面朴'
	},
	{
		comment: '厚大衣朴',
		code: '厚大衣朴'
	},
	{
		comment: '防棉朴',
		code: '防棉朴'
	},
]

export const declarationEmbryoSource = [{
	comment: '自织',
	code: 0
}, {
	comment: '外购',
	code: 1
}]

export const declarationAppeaTestStandFps = [
	{
		comment: '美标四分制',
		code: true
	},
	{
		comment: '其他',
		code: false
	}
]

export const declarationCheckSampleRepStorageLife = [
	{
		comment: '两年',
		code: '2'
	},
	{
		comment: '不保存',
		code: '0'
	},
	{
		comment: '其他',
		code: '-1'
	},
]

export const BomApprovalStatus = [
	{
		comment: '未审核',
		code: '0'
	},
	{
		comment: '已审核',
		code: '1'

	},
	{
		comment: '已退回',
		code: '2'
	}
]

export const vendorChange = [
	{
		comment: '未变更',
		code: '0'
	},
	{
		comment: '已变更',
		code: '1'

	}
]

export const OtherCosts = [
	{
		comment: '主料',
		code: '1'
	},
	{
		comment: '辅料',
		code: '2'
	},
	{
		comment: '撞料',
		code: '3'
	},
	{
		comment: 'FOB',
		code: '4'
	},
	{
		comment: '加工费',
		code: '5'
	},
	{
		comment: '特殊工艺',
		code: '6'
	},
	{
		comment: '毛皮饰品',
		code: '7'

	}
]
export const BomApprovalStatus_Show = enumToFilter(BomApprovalStatus)

export const technicList = [
	{ code: '0', comment: "新开发，从未生产大货" },
	{ code: '1', comment: "新开发，曾生产大货" },
	{ code: '2', comment: "常规产品，曾生产1年以上" },
	{ code: '3', comment: "非本厂生产，外发" }
];

export const washTechnicList = [
	{ code: '0', comment: "普洗" },
	{ code: '1', comment: "重普洗" },
	{ code: '2', comment: "酵洗" },
	{ code: '3', comment: "洗水加软油" },
	{ code: '4', comment: "洗水加树脂" },
	{ code: '5', comment: "洗水加套色" },
	{ code: '6', comment: "钉珠" },
	{ code: '7', comment: "印花" },
	{ code: '8', comment: "绣花" },
	{ code: '9', comment: "烫钻/花" },
]

export const followFlagPlannCost = [
	{ code: 1, comment: '待跟进' },
	{ code: 2, comment: '已跟进' },
]
export const followFlagPlannCost_Show = enumToFilter(followFlagPlannCost);

export const followFlagList = [
	{ code: 'Y', comment: '是' },
	{ code: 'N', comment: '否' },
];

export const followFlagList_Show = enumToFilter(followFlagList);

export const materialTypeList = [
	{ code: '0', comment: '全部' },
	{ code: '1', comment: '面料' },
	{ code: '2', comment: '辅料' },
]
export const materialTypeList_Show = enumToFilter(materialTypeList);


// 赫基快反
export const hasPoOrder = [
	{ code: '', comment: '全部' },
	{ code: '1', comment: '有' },
	{ code: '0', comment: '无' },
]
export const hasPoOrder_Show = enumToFilter(hasPoOrder);

export const saleerReport = [
	{ code: '-1', comment: '全部' },
	{ code: '1', comment: '预警' },
	{ code: '0', comment: '正常' },
]
export const saleerReport_Show = enumToFilter(saleerReport);

export const fastReturnStatus = [
	{ code: '0', comment: '正常' },
	{ code: '1', comment: '下线' },
]


export const fastReturnStatus_Show = enumToFilter(fastReturnStatus);

export const fastReturnSendStatus = [
	{ code: '0', comment: '待发货' },
	{ code: '1', comment: '已发货' },
]

export const fastReturnSendStatus_Show = enumToFilter(fastReturnSendStatus)


export const quoteFlagStatus = [
	{ code: '0', comment: '未报价' },
	{ code: '1', comment: '已报价' },
	{ code: '2', comment: '全部' }
]
export const quoteFlagStatus_Show = enumToFilter(quoteFlagStatus)

export const supplierHasPostStatus = [
	{ code: '0', comment: '未提交' },
	{ code: '1', comment: '已提交' },
]
export const supplierHasPostStatus_Show = enumToFilter(supplierHasPostStatus)

export const supplierPriceStatus = [
	{ code: 'CNY', comment: 'CNY' },
	{ code: 'HKD', comment: 'HKD' },
	{ code: 'USD', comment: 'USD' },
]
export const supplierPriceStatus_Show = enumToFilter(supplierPriceStatus)

export const excipientConfirmflag = [
	{ code: '0', comment: '未确定' },
	{ code: '1', comment: '已确定' },
	{ code: '2', comment: '全部' },
]

export const excipientConfirmflag_Show = enumToFilter(excipientConfirmflag)

export const colorGroupListStatus = [
	{ code: 'COLOR1', comment: 'COLOR1' },
	{ code: 'OLDCOLOR', comment: 'OLDCOLOR' },
	{ code: 'YCOLOR', comment: 'YCOLOR' },
]

export const colorGroupListStatus_Show = enumToFilter(colorGroupListStatus)
export const vendorOrderStatus = [
	// {code: '000', comment: '待处理'},
	// {code: '010', comment: '待资源初审'},
	// {code: '020', comment: '待生管初审'},
	// {code: '033', comment: '待资源评分-生管评分'},
	// {code: '034', comment: '待资源评分-生管意见'},
	// {code: '035', comment: '待资源评分-生管已合作'},
	// {code: '036', comment: '待资源评分-生管已拒绝'},
	// {code: '043', comment: '待资源意见-生管评分'},
	// {code: '044', comment: '待资源意见-生管意见'},
	// {code: '045', comment: '待资源意见-生管已合作'},
	// {code: '046', comment: '待资源意见-生管已拒绝'},
	// {code: '053', comment: '资源已合作-待生管评分'},
	// {code: '054', comment: '资源已合作-待生管意见'},
	// {code: '063', comment: '资源已拒绝-待生管评分'},
	// {code: '064', comment: '资源已拒绝-待生管意见'},
	// {code: '070', comment: '待总监审批'},
	// {code: '080', comment: '待统计审批'},
	// {code: '090', comment: '已完成'},
	// {code: '100', comment: '暂不合作'}

	{code: '000', comment: '待处理'},
	{code: '014', comment: '供应商管理待初审-生管待初审'},
	{code: '015', comment: '供应商管理待初审-生管已初审'},
	{code: '016', comment: '供应商管理待初审-生管已评分'},
	{code: '024', comment: '供应商管理已初审-生管待初审'},
	{code: '025', comment: '供应商管理已初审-生管已初审'},
	{code: '026', comment: '供应商管理已初审-生管已评分'},
	{code: '034', comment: '供应商管理已评分-生管待初审'},
	{code: '035', comment: '供应商管理已评分-生管已初审'},
	// {code: '040', comment: '待生管经理评估'},
	// {code: '050', comment: '待供应商管理评估'},
	{code: '070', comment: '待提交OA审批'},
	{code: '071', comment: 'OA-填写中'},
	{code: '072', comment: 'OA-审批中'},
	{code: '080', comment: '已完成'},
	{code: '090', comment: '暂不合作'},
]
export const vendorOrderStatus_Show = enumToFilter(vendorOrderStatus)

export const costTypeStatus = [
	{ code: '0', comment: '全部' },
	{ code: '1', comment: '企划' },
	{ code: '2', comment: '看图' },
	{ code: '2', comment: '实物' }
]
export const costTypeStatusEnum = [
	{ code: '1', comment: '企划' },
	{ code: '2', comment: '看图' },
	{ code: '3', comment: '实物' }
]

export const costTypeStatus_Show = enumToFilter(costTypeStatus)

export const estimatedCostType = [
	{ code: '1', comment: '主料' },
	{ code: '2', comment: '撞料' },
]

export const bomIsUse = [
	{ code: '0', comment: '未使用' },
	{ code: '1', comment: 'A-BOM使用' },
	{ code: '2', comment: 'B-BOM使用' },
]
export const BomloftFlag = [
	{ code: '1', comment: '已标志' },
	{ code: '0', comment: '未标志' },
]

export const progressSchedulePnodeModelCode = [
	{
		code: 'A',
		comment: '成衣主进度'
	},
	{
		code: 'B',
		comment: '饰品主进度'
	},
	{
		code: 'A050',
		comment: '成衣打样主进度'
	},
	{
		code: 'B050',
		comment: '饰品打样主进度'
	},
	{
		code: 'E050',
		comment: '半成品打样主进度'
	},
	{
		code: 'A050010',
		comment: '特殊工艺打样进度'
	},
	{
		code: 'A090',
		comment: '成衣生产主进度'
	},
	{
		code: 'A090020',
		comment: '面料生产进度'
	},
	{
		code: 'A090040',
		comment: '辅料生产进度'
	},
	{
		code: 'A090110',
		comment: '特殊工艺生产进度'
	},
	{
		code: 'C030',
		comment: '面料打样进度'
	},
	{
		code: 'C040',
		comment: '辅料开发进度'
	},
	{
		code: 'Q',
		comment: '快返开发进度'
	}
]
export const specialmakingStatus = [
	{
		code: '0',
		comment: '未完成'
	},
	{
		code: '1',
		comment: '已完成'
	}
]
export const preformedInvoiceStatus = [
	{
		code: '0',
		comment: '新建'
	},
	{
		code: '1',
		comment: '处理中'
	},
	{
		code: '2',
		comment: '处理完成'
	}
]
export const preformedInvoiceStatus_Show = enumToFilter(preformedInvoiceStatus)

export const preformedInvoiceType = [
	{
		code: '1',
		comment: '质量问题索赔'
	},
	{
		code: '2',
		comment: '打折收货'
	},
	{
		code: '3',
		comment: '修改意见'
	},
]
export const dealWithStatus = [
	{
		code: '0',
		comment: '未处理'
	},
	{
		code: '1',
		comment: '已处理'
	}
]

export const generalStatus = [
	{
		code: '0',
		comment: '未处理'
	},
	{
		code: '1',
		comment: '已工厂反馈'
	},
	{
		code: '2',
		comment: '已跟单补充'
	},
	{
		code: '3',
		comment: '已生管审核'
	},
	{
		code: '4',
		comment: '已统计审核'
	},
	{
		code: '5',
		comment: '业务处理'
	},
]

export const generalStatus_Show = enumToFilter(generalStatus)

export const BrandCodeToSeries = {
	'1': 'Series_1',
	'5': 'Series_5',
	'2': 'Series_2',
	'6': 'Series_6',
	'3': 'Series_3',
	'C': 'Series_C',
}
export const BrandCodeToBrandName = {
	'1': 'ochirly',
	'5': 'ochirly kids',
	'2': 'FivePlus',
	'6': 'MISS SIXTY',
	'3': 'Trendiano',
	'C': 'CovenGarden',
	'7': 'Energie',
	'8': 'Killah',
	'T': 'TrendianoWomen',
	'9': 'OE'
}


export const categoryCodeToName = {
  V001: '服装加工厂',
  V002: '饰品加工厂',
  V003: '面料供应商',
  V004: '辅料供应商',
  V005: '特殊工艺'
}

// 把枚举值 过滤为显示的filter
export function enumToFilter(array) {
	return array.reduce((pre, next) => {
		pre[next.code] = next.comment;
		return pre;
	}, {})
}

export const sendType =	[
	{
		code: '7',
		comment:'返修处理'
	},
	{
		 code:'6',
		 comment:'补寄处理'
	},
	{
		code:'9',
		 comment:'工厂退总仓'
	}
]
export const currentStatus =	[
	{
		code: '0',
		comment:'待客户处理'
	},
	{
		code: '1',
		comment:'待质量管理处理'
	},
	{
		code: '2',
		comment:'处理完成'
	},
	{
		code: '3',
		comment:'待工厂确认'
	},
	{
		code: '4',
		comment:'待客户寄回工厂'
	},
	{
		code: '5',
		comment:'待客户寄回赫基仓库'
	},
	{
		code: '7',
		comment:'返修处理'
	},
	{
		code: '8',
		comment:'待客户确认收货'
	},
	{
		 code:'6',
		 comment:'补寄处理'
	},
	{
		code:'9',
		 comment:'工厂退总仓'
	}
]

export const problemGroupType = {
	'1': '工厂问题'
}

// export const processModeType = {
// 	'010': '接受退货',
// 	'020': '退场返修',
// 	'030': '已使用，不接受退货',
// 	'040': '工厂补寄',
// 	'050': '寄回判定',
// 	'060': '驳回，重新提交',
// 	'070': '客户原因，工厂协助返修',
// }

export const basePaidList = [
	{
		comment: '是',
		code: '1'
	},
	{
		comment: '否',
		code: '0'
	}
]

export const SAPSyncResult = [
	{
		comment: '已成功',
		code: '1'
	},
	{
		comment: '未成功',
		code: '0',
	}
]
export const SPSFlagStatus = [
	{
		comment: '已同步',
		code: '1'
	},
	{
		comment: '未同步',
		code: '0'
	}
]

export const SAPSyncResult_show = enumToFilter(SAPSyncResult)
export const SPSFlagStatus_show = enumToFilter(SPSFlagStatus)



export const BoxingWay = [
	{
		comment: '',
		code: ''
	},
	{
		comment: '标准',
		code: '标准'
	},
	{
		comment: '混合',
		code: '混合'
	}
]
export const BoxingWay_show = enumToFilter(BoxingWay)

export const AuditStatus = [
	{
		comment: '',
		code: ''
	},
	{
		comment: '已审核',
		code: '1'
	},
	{
		comment: '待审核',
		code: '0'
	}
]
export const AuditStatus_show = enumToFilter(AuditStatus)
export const materialStatus = [
	{
		comment: '',
		code: ''
	},
	{
		comment: '下架',
		code: '1'
	},
	{
		comment: '默认上架',
		code: '0'
	}
]
export const materialStatus_show = enumToFilter(materialStatus)
export const inventory = [
	{
		comment: '',
		code: ''
	},
	{
		comment: '0-1000',
		code: '0-1000'
	},{
		comment: '1000-3000',
		code: '1000-3000'
	},{
		comment: '3000-5000',
		code: '3000-5000'
	},{
		comment: '5000以上',
		code: '5000以上'
	},


]
export const stockStatusStatus = [
	{
		comment: '',
		code: ''
	},
	{
		comment: '待更新',
		code: '1'
	},{
		comment: '已更新',
		code: '2'
	}
]
export const sendStatus = [
	{
		comment: '已发货',
		code: '1'
	},
	{
		comment: '取消',
		code: '0'
	},
	{
		comment: '已收货',
		code: '2'
	}
]
export const sendStatus_Show = enumToFilter(sendStatus);
export const periods = [
	{
		comment: '第一期',
		code: '1'
	},{
		comment: '第二期',
		code: '2'
	},{
		comment: '第三期',
		code: '3'
	},{
		comment: '第四期',
		code: '4'
	},{
		comment: '第五期',
		code: '5'
	},{
		comment: '第六期',
		code: '6'
	},
]
export const periods_Show = enumToFilter(periods);
export const brands = [
	{
		comment: 'ochirly',
		code: '1'
	},{
		comment: 'FivePlus',
		code: '2'
	},{
		comment: 'Trendiano',
		code: '3'
	}/*,{
		comment: 'ochirly kids',
		code: '4'
	}*/,{
		comment: 'ochirly kids',
		code: '5'
	},{
		comment: 'MISS SIXTY',
		code: '6'
	},{
		comment: 'Energie',
		code: '7'
	},{
		comment: 'Killah',
		code: '8'
	},{
		comment: 'CovenGarden',
		code: 'C'
	},{
		comment: 'DENHAM',
		code: 'U'
	},{
		comment: 'TrendianoWomen',
		code: 'W'
	},{
		comment: 'WAXY',
		code: 'X'
	},
]
export const brands_Show = enumToFilter(brands);

export const scanType = [
	{
		comment: '带换行符',
		code: '0'
	},
	{
		comment: '不带换行符',
		code: '1'
	}
]
export const suppleHandleStatus = [
	{
		comment: '',
		code: null
	},
	{
		comment: '待提交',
		code: '110'
	},
	{
		comment: '待审核',
		code: '120'
	},
	{
		comment: '已审核',
		code: '130'
	},
	{
		comment: '已驳回',
		code: '140'
	},
	
]
export const suppleHandleStatus_Show = enumToFilter(suppleHandleStatus);

export const poContractStatus = [
	{
		comment: '',
		code: null
	},
	{
		comment: '待发起签署',
		code: '0'
	},
	{
		comment: '签署中',
		code: '1'
	},
	{
		comment: '已失效',
		code: '2'
	},
	{
		comment: '审批拒绝',
		code: '3'
	},
	{
		comment: '签署完成',
		code: '4'
	},
	{
		comment: '签署完成，作废走线下流程',
		code: '5'
	},
	{
		comment: '作废中',
		code: '6'
	},
	{
		comment: '已作废',
		code: '7'
	},
	{
		comment: '拒绝作废',
		code: '8'
	},
	{
		comment: 'OA编辑中',
		code: '10'
	},
	
]
export const poContractStatus_Show = enumToFilter(poContractStatus);

export const dealStatus = [
	{
		comment: '',
		code: null
	},
	{
		comment: '已处理',
		code: '1'
	},
	{
		comment: '未处理',
		code: '0'
	}
]
export const dealStatus_Show = enumToFilter(dealStatus);
export const stateFlagStatus = [
	{
		comment: '已发起退货',
		code: '0'
	},
	{
		comment: '已取消退货',
		code: '1'
	},
	{
		comment: '中台已发货',
		code: '2'
	},
	{
		comment: '已冻结',
		code: '3'
	},
	{
		comment: '冻结中',
		code: '4'
	}
]
export const stateFlagStatus_Show = enumToFilter(stateFlagStatus);
export const receiveStatus = [
	{
		comment: '未领料',
		code: '0'
	},
	{
		comment: '部分领料',
		code: '3'
	},
	{
		comment: '完成领料',
		code: '7'
	}
]
export const receiveStatus_Show = enumToFilter(receiveStatus);
export const cmtSendStatus = [
	{
		comment: '未发料',
		code: '0'
	},
	{
		comment: '部分发料',
		code: '3'
	},
	{
		comment: '完成发料',
		code: '7'
	}
]
export const smtSendStatus_Show = enumToFilter(cmtSendStatus);
export const materialType = [
	{
		comment: 'F 辅料',
		code: 'F'
	},
	{
		comment: 'J 辅料',
		code: 'J'
	},
	{
		comment: 'M 面料',
		code: 'M'
	},
	{
		comment: 'O 旧款',
		code: 'O'
	},
	{
		comment: 'Z 主料',
		code: 'Z'
	}
]
export const materialType_Show = enumToFilter(materialType);
